function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M72.7209 64C85.5285 64 95.3713 55.4616 97.2687 43.2471C99.0475 31.3882 91.8136 22.4941 79.3026 22.4941H65.7835L58.7275 64H72.7209ZM78.2353 30.2024C85.7064 30.2024 89.8569 35.3016 88.6118 43.2471C87.248 51.4889 80.9628 56.2325 73.3139 56.2325H68.6296L73.136 30.2024H78.2353ZM99.0661 50.3624C98.0581 58.1299 102.268 64.5336 109.68 64.5336C113.652 64.5336 117.032 62.6362 119.404 59.6122L118.692 64H126.163L130.848 36.7247H123.317L122.428 41.9426C121.064 38.5035 118.337 36.1911 114.008 36.1318C106.656 36.0725 100.133 42.2391 99.0661 50.3624ZM106.952 50.3624C107.664 46.0339 111.399 42.4169 115.609 42.5355C119.345 42.6541 121.42 46.2711 120.886 50.3624C120.175 54.6908 116.321 58.1892 112.526 58.1299C108.375 58.0706 106.359 54.4536 106.952 50.3624ZM135.768 54.6315L131.558 59.3158C134.464 62.3398 138.733 64.9487 144.307 64.9487C150.295 64.9487 154.446 61.4504 154.742 56.1139C154.979 51.3704 151.778 49.4136 147.805 47.7534C145.077 46.6268 142.409 45.9153 142.587 43.84C142.646 42.5355 143.951 41.5868 145.848 41.5868C148.339 41.5868 150.829 43.2471 152.667 45.2631L156.284 40.5788C153.675 38.0885 150.117 36.1318 145.67 36.1318C140.571 36.1318 135.887 38.7407 135.59 43.9586C135.353 48.5835 138.733 50.7774 142.172 52.0819C144.959 53.0899 147.331 54.1572 147.271 56.2918C147.212 57.8334 145.789 59.0786 143.891 59.0786C141.045 59.1972 138.436 57.3591 135.768 54.6315ZM177.082 47.3976L174.176 64H181.766L184.79 46.3304C185.62 40.3416 183.604 35.8353 177.2 35.8353C173.465 35.8353 170.619 37.7327 168.721 40.4009L172.635 17.7506H164.986L157.04 64H164.63L167.535 47.0419C168.366 44.2551 170.678 41.7647 173.821 41.8833C176.963 42.0019 177.438 44.4922 177.082 47.3976Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 40,
  width: 36,
  height: 6,
  rx: 3,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 53,
  width: 36,
  height: 6,
  rx: 3,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 27,
  width: 36,
  height: 6,
  rx: 3,
  fill: "currentColor"
});

function SvgLogo(_ref) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 86,
    viewBox: "0 0 187 86",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "1161198fd2e5a3e1b29c5bd09e848a98.svg";
export { SvgLogo as ReactComponent };